module.exports = __webpack_public_path__ + "img/color-bar.59f76681.png";